<template>
  <div class="myhome-cities-list__container dea-border-grey-medium">
    <ul>
      <li v-for="(el, idx) in highlighted" :key="idx" @click="selectCity(el.city)">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="el.label"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CitiesList",
  props: {
    citiesList: {
      type: Array,
      default: () => [],
    },
    query: {
      type: String,
      default: "",
    },
  },
  computed: {
    highlighted() {
      if (this.query) {
        const cities = this.citiesList.map(el => {
          const regEx = new RegExp(this.query, "ig");
          const obj = { ...el };
          obj.label = obj.city.replace(
            regEx,
            "<span class='dea-autosuggest-result dea-autosuggest-result--highlight'>$&</span>"
          );
          return obj;
        });
        return cities;
      }
      return this.citiesList;
    },
  },
  methods: {
    selectCity(city) {
      this.$emit("city-selected", city);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
$cities-list-max-height: 250px;

.myhome-cities-list__container {
  border: $border-light;

  ul {
    list-style: none;
    max-height: $cities-list-max-height;
    overflow-y: auto;

    li {
      margin: $space-small 0;
    }
  }
}
</style>
